// Código inicial da simulação, não o código final devolvido pela TOTVS.
// Nunca inferir pela natureza previamente gravada na capa: a UF de entrega
// ou o estabelecimento podem ter mudado desde o último cálculo.
export function selecionarNaturezaFiscal(contexto, { endereco, estabelecimento, cliente } = {}) {
  const form = contexto?.clienteData || contexto || {};
  const cadastro = cliente || form.cliente || form;
  const origem = estabelecimento || form.estabelecimento || form.dataCapaPedido || form;
  const destino = endereco || form.enderecoAlternativo || form.enderecoEntrega || { pedidoentregauf: form.pedidoentregauf };
  const ufOrigem = String(origem.ufid || origem.ufestabelecimento || '').trim().toUpperCase();
  const ufDestino = String(destino.ufid || destino.uf || destino.pedidoentregauf || '').trim().toUpperCase();
  if (!ufOrigem || !ufDestino) {
    throw new Error('Informe a UF do estabelecimento e a UF de entrega antes de simular impostos.');
  }
  const campo = ufOrigem === ufDestino ? 'clientenatoperinterna' : 'clientenatoperexterna';
  const codigo = String(cadastro[campo] ?? '').trim();
  // Cadastro incompleto não bloqueia a operação: o ERP recebe a natureza
  // inicial vazia e devolve o resultado fiscal. Nunca inventar um CFOP.
  return codigo === '0' ? '' : codigo;
}